import axios from "axios";

export default {
  add(usuario) {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .post("api/usuario", usuario, headerAuth)
      .then((result) => {
        console.log(result);
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  update(usuario) {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .put(`api/usuario/${usuario.usuarioId}`, usuario, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },

  getUsuarios() {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .get("api/usuarios", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  getAllForGrid() {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .get("api/usuarios/grid", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  getById(usuarioId) {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .get(`api/usuario/${usuarioId}`, headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },

  getCurrent() {
    const tokenAuth = localStorage.getItem("access_token");
    const headerAuth = {
      headers: {
        Authorization: `${tokenAuth}`,
      },
    };

    return axios
      .get("api/current-user", headerAuth)
      .then((result) => {
        return result.data;
      })
      .catch((e) => {
        console.log(e);
        throw e;
      });
  },
};
